const initialState = {
  products: [],
  filterProducts: [],
  cart: [],
  address: [],
};

const productReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "SET_PRODUCTS":
      return {
        ...state,
        products: payload,
      };
    case "SET_FILTER_PRODUCTS":
      return {
        ...state,
        filterProducts: payload,
      };
    case "SET_CARTS":
      return {
        ...state,
        cart: payload,
      };
    case "SET_ADDRESS":
      return {
        ...state,
        address: payload,
      };
    default:
      return state;
  }
};

export default productReducer;
